export default __webpack_public_path__ + "SolutionImage2.f7e7554.png";